import { Component, OnInit, OnDestroy, } from '@angular/core';
import { filter, Observable, Subject, switchMap, takeUntil } from 'rxjs';

import { IrisButtonContainerAlignments, IrisButtonTypes } from '@sondermind/iris/button';
import { IrisButtonTypeAttributeOptions } from '@sondermind/iris/shared';
import { Patient } from '@sondermind/utilities/models-patient';

import { ClientDetailPageService } from '@sondermind/features/provider-facing/client-detail';
import { PrescriptionNotificationStore, PrescriptionsHttpService } from '@sondermind/data-access/prescriptions';
import { PrescriptionModalService } from '@sondermind/features/provider-facing/eprescription';

@Component({
  selector: 'member-client-detail-prescriptions-info',
  templateUrl: './client-detail-prescriptions-info.component.html',
  styleUrls: ['./client-detail-prescriptions-info.component.scss'],
  standalone: false
})
export class ClientPrescriptionsInfoPage implements OnInit, OnDestroy {
  IrisButtonTypes = IrisButtonTypes;
  IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions;
  IrisButtonContainerAlignment = IrisButtonContainerAlignments;

  private destroyedSubj: Subject<void>;
  destroyed$: Observable<void>;
  patient: Patient;
  isEligible = false;

  constructor(
    private prescriptionsService: PrescriptionsHttpService,
    private notifStore: PrescriptionNotificationStore,
    private prescriptionModalService: PrescriptionModalService,
    private clientDetailPageService: ClientDetailPageService,
  ) {
    this.destroyedSubj = new Subject();
    this.destroyed$ = this.destroyedSubj.asObservable();
  }

  ngOnInit(): void {
    this.clientDetailPageService.patient.subscribe((p) => {
      this.patient = p;
      this.isEligible = !!p.personaClientId;
    });
  }

  ngOnDestroy(): void {
    this.destroyedSubj.next();
    this.destroyedSubj.complete();
  }

  openRcopiaModal(): void {
    this.prescriptionModalService.openRcopiaModalForPatient$(this.patient.id, this.patient.personaClientId)
      .pipe(
        takeUntil(this.destroyed$),
        filter((result) => result === 'closed'),
        switchMap(() => this.prescriptionsService.notifyPrescriptionChange$(this.patient.id)),
        switchMap(() => this.notifStore.getNotificationCounts$(true))
      ).subscribe();
  }
}
